module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-row', [_c('b-col', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "sm": _vm.documentSize
    }
  }, [_c('div', {
    class: {
      focusedDoc: _vm.focusDoc
    },
    on: {
      "click": _vm.switchFocusDoc
    }
  }, [(_vm.documentType === 'pdf' && _vm.documentDataForPDF.data) ? _c('pdf', {
    ref: "pdf",
    attrs: {
      "src": _vm.documentDataForPDF,
      "page": _vm.page,
      "rotate": _vm.rotation
    },
    on: {
      "progress": function($event) {
        _vm.loadedRatio = $event
      },
      "numPages": function($event) {
        _vm.numPages = $event
      }
    }
  }) : _c('img', {
    ref: "imgRef",
    style: (("margin-bottom: " + _vm.mBottom + "px; margin-top: " + _vm.mTop + "px; transform: rotate(" + _vm.rotation + "deg);width:100%;")),
    attrs: {
      "src": _vm.src
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-block",
      "text-align": "center",
      "width": "100%"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.page + '/' + _vm.numPages) + "\n    ")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-af21afac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af21afac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DocumentViewer.vue
// module id = 2495
// module chunks = 2